const obraSocialInitialState = {
    obraSocial: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default obraSocialInitialState;